import {simpleAction} from "../../utils";
import * as TYPES from "./types";

/**
 * Request Products
 * @type {function(type: string): {type: string, payload: any}}
 */
export const packagesGetRequest = simpleAction(TYPES.PACKAGES_GET_REQUEST);

/**
 * Request packages success
 * @param payload
 * @type {function(type: string): {type: string, payload: any}}
 */
export const packagesGetSuccess = simpleAction(TYPES.PACKAGES_GET_SUCCESS);

/**
 * Request packages error
 * @type {function(type: string): {type: string, payload: any}}
 */
export const packagesGetError = simpleAction(TYPES.PACKAGES_GET_FAIL);

/**
 * Request Order
 * @type {function(type: string): {type: string, payload: any}}
 */
export const packageLoadRequest = simpleAction(TYPES.PACKAGE_LOAD_REQUEST);

/**
 * Request Order success
 * @param payload
 * @type {function(type: string): {type: string, payload: any}}
 */
export const packageLoadSuccess = simpleAction(TYPES.PACKAGE_LOAD_SUCCESS);

/**
 * Request Order error
 * @type {function(type: string): {type: string, payload: any}}
 */
export const packageLoadError = simpleAction(TYPES.PACKAGE_LOAD_FAIL);

/**
 * Create Order
 * @type {function(type: string): {type: string, payload: any}}
 */
export const packageCreateRequest = simpleAction(TYPES.PACKAGE_CREATE_REQUEST);

/**
 * Create Order Success
 * @param payload
 * @type {function(type: string): {type: string, payload: any}}
 */
export const packageCreateSuccess = simpleAction(TYPES.PACKAGE_CREATE_SUCCESS);

/**
 * Create Order Error
 * @type {function(type: string): {type: string, payload: any}}
 */
export const packageCreateError = simpleAction(TYPES.PACKAGE_CREATE_FAIL);

/**
 * Create Order Error
 * @type {function(type: string): {type: string, payload: any}}
 */
export const packageCreateDone = simpleAction(TYPES.PACKAGE_CREATE_DONE);

/**
 * Update Order
 * @type {function(type: string): {type: string, payload: any}}
 */
export const packageUpdateRequest = simpleAction(TYPES.PACKAGE_UPDATE_REQUEST);

/**
 * Update Order Success
 * @param payload
 * @type {function(type: string): {type: string, payload: any}}
 */
export const packageUpdateSuccess = simpleAction(TYPES.PACKAGE_UPDATE_SUCCESS);

/**
 * Update Order Error
 * @type {function(type: string): {type: string, payload: any}}
 */
export const packageUpdateError = simpleAction(TYPES.PACKAGE_UPDATE_FAIL);

/**
 * Update Order Error
 * @type {function(type: string): {type: string, payload: any}}
 */
export const packageUpdateDone = simpleAction(TYPES.PACKAGE_UPDATE_DONE);
